<h1 mat-dialog-title>Patient Details</h1>
<mat-dialog-content>
  @if (form !== null) {
    <form class="new-appointment-form" [formGroup]="form">
      <mat-form-field appearance="fill" class="w-100" >
        <mat-label>Name</mat-label>
        <input matInput [formControlName]="'name'">
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Cell</mat-label>
        <input matInput [formControlName]="'cell'" type="tel" maxlength="12" xuiInputFormatter [formatPattern]="'phone_number'">
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Email</mat-label>
        <input matInput [formControlName]="'email'" type="email">
      </mat-form-field>
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="mx-3 mb-2">
  <button mat-button (click)="close()" >Cancel</button>
  <button mat-flat-button color="primary" (click)="save()">Save</button>
</mat-dialog-actions>
